/**
 * NANOAGRO — Espejo de expedientes al servidor  (asset del tema)
 *
 * Qué hace: cada vez que un formulario del sitio guarda en el navegador
 * (`ftd_sessions` = ensayo y Field Trial · `na_soil_forms` = hoja de suelo),
 * este archivo manda una copia al servidor, para que el expediente exista de verdad
 * y no solo en el equipo de quien lo llenó.
 *
 * Por qué así y no editando cada formulario: hay cuatro formularios repartidos en
 * páginas distintas y todos ya guardan en esas dos llaves. Enganchándose en el punto
 * donde guardan, quedan cubiertos los cuatro —y cualquiera que se agregue después—
 * sin tocar ni una línea de sus archivos. Si este script falla, el formulario sigue
 * funcionando igual que hoy: guardar en el navegador nunca se interrumpe.
 *
 * Dónde se instala: Shopify → Editar código → Assets → `nanoagro-expedientes.js`,
 * y una línea en `theme.liquid` antes de </body>:
 *     <script src="{{ 'nanoagro-expedientes.js' | asset_url }}" defer></script>
 * Va en theme.liquid (no en el dashboard) porque los formularios viven en páginas
 * públicas, fuera del dashboard.
 */
(function () {
  'use strict';

  var API = '/apps/expedientes';     // App Proxy de Shopify → worker nanoagro-expedientes
  var YA_ENVIADOS = 'na_exp_enviados';
  var LLAVES = { ftd_sessions: 'ftd', na_soil_forms: 'suelo' };

  /* ── Registro de lo ya enviado, para no duplicar ──────────────────────────────
     Los formularios reescriben el arreglo completo cada vez (también al borrar),
     así que sin esto mandaríamos el mismo expediente una y otra vez. */
  function enviados() {
    try { var a = JSON.parse(localStorage.getItem(YA_ENVIADOS) || '[]'); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }
  function marcar(id) {
    try {
      var a = enviados();
      if (a.indexOf(id) === -1) a.push(id);
      localStorage.setItem(YA_ENVIADOS, JSON.stringify(a.slice(-400)));
    } catch (e) { /* si el navegador no deja guardar, peor es no enviar nada */ }
  }

  /* ── Un resumen corto para la lista del dashboard ─────────────────────────── */
  function resumir(reg, tipo) {
    var p = reg || {};
    var trozos = [];
    ['cultivo', 'crop', 'finca', 'empresa', 'company', 'modalidad', 'formulacion'].forEach(function (k) {
      for (var real in p) {
        if (real.toLowerCase() === k && p[real] && trozos.length < 3) { trozos.push(String(p[real])); break; }
      }
    });
    return trozos.join(' · ').slice(0, 200) || (tipo === 'suelo' ? 'Hoja de suelo' : 'Solicitud');
  }

  /* ── Meta: evento Lead desde el navegador ─────────────────────────────────────
     El píxel de Meta vive en la caja de Shopify, así que aquí NO se llama a fbq: se
     publica `nano_formulario_enviado` y el píxel personalizado "Nano Agro eventos
     propios" lo convierte en Lead (meta-pixel-personalizado.js). Lleva el MISMO id
     que el Lead que manda el worker desde el servidor → Meta deduplica.
     Solo ensayo y suelo: el FTD lo arma un distribuidor dentro del dashboard, no es
     un cliente nuevo.
     El formulario de ensayo es el de contacto nativo de Shopify: al enviarlo, la
     página navega y el evento puede perderse. Por eso queda apuntado en
     sessionStorage y se vuelve a publicar en la página siguiente (mismo id: Meta
     no lo cuenta dos veces). */
  var LEAD_PENDIENTE = 'na_lead_pendiente';
  var TIPOS_LEAD = { ensayo: 1, suelo: 1 };

  function publicarLead(id, tipo) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('nano_formulario_enviado', { id: id, tipo: tipo });
      }
    } catch (e) { /* un evento de marketing nunca rompe el formulario */ }
  }

  function cookie(nombre) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + nombre + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  window.addEventListener('load', function () {
    try {
      var p = JSON.parse(sessionStorage.getItem(LEAD_PENDIENTE) || 'null');
      sessionStorage.removeItem(LEAD_PENDIENTE);
      // 15 min de margen: si el usuario vuelve mucho después, ya no es el mismo envío
      if (p && p.id && Date.now() - (p.t || 0) < 15 * 60 * 1000) publicarLead(p.id, p.tipo);
    } catch (e) { /* sin sessionStorage: se queda solo el Lead del servidor */ }
  });

  /* ── Envío ────────────────────────────────────────────────────────────────── */
  function enviar(reg, llave) {
    if (!reg || typeof reg !== 'object') return;

    var id = reg.id || reg.code || '';
    if (!id) return;                          // sin identificador no podemos evitar duplicados
    if (enviados().indexOf(id) !== -1) return;

    // `ftd_sessions` mezcla dos cosas: la solicitud pública de ensayo y el diseño
    // de ensayo de campo hecho en el dashboard. Se distinguen por _source.
    var tipo = LLAVES[llave];
    if (llave === 'ftd_sessions') tipo = (reg._source === 'trial-form') ? 'ensayo' : 'ftd';

    marcar(id);   // se marca ANTES: si la red falla, mejor perder uno que enviar cien

    if (TIPOS_LEAD[tipo]) {
      publicarLead(id, tipo);
      try { sessionStorage.setItem(LEAD_PENDIENTE, JSON.stringify({ id: id, tipo: tipo, t: Date.now() })); }
      catch (e) { /* sin sessionStorage: basta con el de arriba y el del servidor */ }
    }

    fetch(API + '/guardar', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: id,               // el mismo id que usa el navegador: evita duplicados en la lista
        tipo: tipo,
        payload: reg,
        resumen: resumir(reg, tipo),
        origen: location.pathname,
        // cookies de Meta (si existen): mejoran la coincidencia del Lead del servidor
        fbp: cookie('_fbp'),
        fbc: cookie('_fbc'),
      }),
      keepalive: true,        // sobrevive si la página navega justo después de enviar
    }).catch(function () { /* el formulario ya quedó guardado en el navegador */ });
  }

  /* ── El enganche ──────────────────────────────────────────────────────────── */
  var guardarOriginal = localStorage.setItem.bind(localStorage);

  localStorage.setItem = function (llave, valor) {
    guardarOriginal(llave, valor);            // primero lo de siempre, pase lo que pase
    if (!LLAVES[llave]) return;
    try {
      var arr = JSON.parse(valor);
      if (!Array.isArray(arr) || !arr.length) return;
      // Los formularios insertan el nuevo al principio (unshift). Se revisan los dos
      // primeros por si alguno ordena distinto; el registro de enviados evita repetir.
      enviar(arr[0], llave);
      if (arr.length > 1) enviar(arr[1], llave);
    } catch (e) { /* valor que no es una lista: no es un expediente */ }
  };
})();